import { gettext } from '@eventbrite/i18n';
import { Button, CalendarOffIcon, InlineAlert } from '@eventbrite/marmalade';
import React from 'react';
import { SALES_STATUS_CODE } from '../../types';
import { BadgeFactory, BadgeType } from '../Badges/BadgeFactory';

export type EnhancedExpiredBadgeProps = {
    onViewDetailsClick?: () => void;
    isEventDetailsPage: boolean;
    salesMessage: string;
    salesMessageCode: SALES_STATUS_CODE;
};

const salesMessageCodeToBadgeType = {
    [SALES_STATUS_CODE.TICKETS_WITH_SALES_ENDED_KEY]: BadgeType.salesEnded,
    [SALES_STATUS_CODE.EVENT_POSTPONED_KEY]: BadgeType.postponed,
    [SALES_STATUS_CODE.EVENT_CANCELLED_KEY]: BadgeType.cancelled,
    [SALES_STATUS_CODE.TICKETS_SOLD_OUT_KEY]: BadgeType.soldOut,
    [SALES_STATUS_CODE.EVENT_ENDED_KEY]: BadgeType.eventEnded,
};

export const EnhancedExpiredEventsBadge: React.FunctionComponent<
    EnhancedExpiredBadgeProps
> = ({
    onViewDetailsClick,
    isEventDetailsPage,
    salesMessage,
    salesMessageCode,
}) => {
    const badgeType = salesMessageCodeToBadgeType[salesMessageCode];

    if (badgeType) {
        return <BadgeFactory type={badgeType} />;
    }

    const cta = !isEventDetailsPage ? (
        <Button variant="ghost" onClick={onViewDetailsClick}>
            {gettext('View event')}
        </Button>
    ) : undefined;

    return (
        <InlineAlert
            className="enhanced-expired-badge"
            variant="warning"
            description={gettext('%(salesMessage)s', { salesMessage })}
            icon={
                <CalendarOffIcon
                    color="#3A3247"
                    className="enhanced-expired-badge__icon"
                />
            }
            cta={cta}
        />
    );
};
